import React from 'react'
import { useHref, useLinkClickHandler } from 'react-router-dom'

type Props = {
  children: (props: {
    INTERNAL_nativeOnClick: (event: React.MouseEvent) => void
    href: string
    target?: string
  }) => React.ReactNode
  replace?: boolean
  state?: unknown
  target?: string
  to: string
}

export const Link = ({ replace = false, state, target, to, children }: Props) => {
  const href = useHref(to)
  const handleClick = useLinkClickHandler<Element>(to, {
    replace,
    state,
    target,
  })

  return children({ href, INTERNAL_nativeOnClick: handleClick, target })
}
